export default "__VITE_ASSET__xpF4Aq3C__"